(function() {
  // Log a simple message to verify the script is loaded.
  console.log("cart-override.js loaded");

  // Helper: Run a function once the DOM is ready.
  function onReady(fn) {
    if (document.readyState !== "loading") {
      fn();
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  }

  // 1. Inject your custom CSS into the head.
  function injectCustomCSS() {
    if (!document.getElementById("kaktus-custom-css")) {
      var customCSS = `
/* Your custom CSS for the Kaktus Cart Drawer */
.kaktusc-cart__offer-product-variant {color: transparent;}
.kaktusc-cart__product-content {max-width: 200px;}
@media only screen and (max-width:420px) {
  .kaktusc-cart__discount-code-in {max-width: 120px;} 
  .kaktusc-cart__offer-product-title {max-width: 70px;} 
  .kaktusc-cart__product-content {max-width: 70px;}
}
#kaktusc-root .kaktusc-cart__product[data-id="49082495009033"] .kaktusc-cart__product-delete {
  all: unset !important;
  display: none !important;
  pointer-events: none !important;
}

/* Hide plus/minus controls for all products while keeping quantity visible */
.kaktusc-cart__product:not([data-id="49082495009033"]) .kaktusc-cart__product-qnt--minus,
.kaktusc-cart__product:not([data-id="49082495009033"]) .kaktusc-cart__product-qnt--plus {
  display: none !important;
}
/* Style regular product quantities with multiplication symbol */
.kaktusc-cart__product:not([data-id="49082495009033"]) .kaktusc-cart__product-qnt::after {
  content: "×" !important;
  font-size: 20px !important;
  margin-left: 2px !important;
}
/* Move Lieferoption above editor content */
.kaktusc-cart__products {
  display: flex !important;
  flex-direction: column !important;
}
/* Style Lieferoption container */
.kaktusc-cart__product[data-id="49082495009033"] {
  order: 1;
  background-color: #f8f8f8 !important;
  padding: 8px 15px;
  margin: 8px 0 4px;
  width: 100%;
  border: none;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
/* Hide unnecessary elements */
.kaktusc-cart__product[data-id="49082495009033"] .kaktusc-cart__product-img,
.kaktusc-cart__product[data-id="49082495009033"] .kaktusc-cart__product-delete,
.kaktusc-cart__product[data-id="49082495009033"] .kaktusc-cart__product-qnt--minus,
.kaktusc-cart__product[data-id="49082495009033"] .kaktusc-cart__product-qnt--plus {
  display: none !important;
}

/* Style content area */
.kaktusc-cart__product[data-id="49082495009033"] .kaktusc-cart__product-content {
  flex: 1 !important;
  padding-right: 15px !important;
}

/* Title styling */
.kaktusc-cart__product[data-id="49082495009033"] .kaktusc-cart__product-title {
  font-size: 18px !important;
  color: #191919 !important;
  margin: 0 0 4px 0 !important;
  font-weight: 500 !important;
  line-height: 20px !important;
}

/* Create text flow for variant and quantity */
.kaktusc-cart__product[data-id="49082495009033"] .kaktusc-cart__product-variant,
.kaktusc-cart__product[data-id="49082495009033"] .kaktusc-cart__product-qnt-wrap {
  display: inline !important;
}

.kaktusc-cart__product[data-id="49082495009033"] .kaktusc-cart__product-variant {
  font-size: 14px !important;
  color: #666 !important;
}

.kaktusc-cart__product[data-id="49082495009033"] .kaktusc-cart__product-qnt {
  font-size: 14px !important;
  color: #666 !important;
}

/* Add spacing before quantity */
.kaktusc-cart__product[data-id="49082495009033"] .kaktusc-cart__product-qnt::before {
  content: " (";
}

.kaktusc-cart__product[data-id="49082495009033"] .kaktusc-cart__product-qnt::after {
  content: "×)";
}

/* Price section styling */
.kaktusc-cart__product[data-id="49082495009033"] .kaktusc-cart__product-price-section {
  display: flex !important;
  align-items: center !important;
  flex-shrink: 0 !important;
  width: 5%;
  justify-content: flex-end;
}

.kaktusc-cart__product[data-id="49082495009033"] .kaktusc-cart__product-price-wrap {
  margin: 0;
  min-width: 80px;
  text-align: right;
}

.kaktusc-cart__product[data-id="49082495009033"] .kaktusc-cart__product-price-discounted {
  font-size: 18px !important;
  color: #191919 !important;
  font-weight: 500 !important;
  line-height: 20px !important;
}

/* Other products styling */
.kaktusc-cart__product:not([data-id="49082495009033"]) {
  order: 0 !important;
}

.kaktusc-cart__editor-wrap {
  order: 2 !important;
}

.kaktusc-cart__product-price-discounted {
  min-width: 80px !important;
  text-align: right !important;
  display: inline-block !important;
}

@media screen and (max-width: 420px) {
  /* Override the max-width for Lieferoption content */
  .kaktusc-cart__product[data-id="49082495009033"] .kaktusc-cart__product-content {
    max-width: none !important;
    flex: 1 !important;
    min-width: 0;
  }

  /* Adjust price section width for mobile */
  .kaktusc-cart__product[data-id="49082495009033"] .kaktusc-cart__product-price-section {
    width: auto;
    min-width: 85px;
    padding-left: 8px;
  }

  /* Ensure variant and quantity stay together */
  .kaktusc-cart__product[data-id="49082495009033"] .kaktusc-cart__product-variant {
    white-space: nowrap !important;
  }

  /* Prevent unnecessary line breaks */
  .kaktusc-cart__product[data-id="49082495009033"] {
    flex-wrap: nowrap !important;
  }
}
      `;
      var styleElement = document.createElement("style");
      styleElement.id = "kaktus-custom-css";
      styleElement.type = "text/css";
      styleElement.textContent = customCSS;
      document.head.appendChild(styleElement);
      console.log("Custom CSS injected");
    } else {
      console.log("Custom CSS already present");
    }
  }

  // 2. Override text content in the Cart Drawer.
  function overrideCartTexts() {
    // Use the domain as the sole trigger for English translations.
    var isEnglish = window.location.hostname === "en.beglaubigung24.de";
    console.log("overrideCartTexts - isEnglish:", isEnglish);

    // Update text content on key elements.
    var cartTitle = document.querySelector(".kaktusc-cart__top h2");
    if (cartTitle) {
      cartTitle.textContent = isEnglish ? "Your Cart" : "Dein Warenkorb";
      console.log("Cart title set to:", cartTitle.textContent);
    }

    var timerMsg = document.querySelector(".kaktusc-cart__timer-msg");
    if (timerMsg) {
      timerMsg.textContent = isEnglish ? "Your cart expires in " : "Der Warenkorb wird in ";
      console.log("Timer message set");
    }
    var timerMsgOther = document.querySelector(".kaktusc-cart__timer-msg-other");
    if (timerMsgOther) {
      timerMsgOther.textContent = isEnglish ? " minutes" : " Minuten ablaufen";
    }

    var discountCodeTxt = document.querySelector(".kaktusc-cart__discount-code-txt");
    if (discountCodeTxt) {
      discountCodeTxt.textContent = isEnglish ? "Discount Code" : "Rabatt-Code";
    }
    var discountBtn = document.querySelector(".kaktusc-cart__discount-code-btn");
    if (discountBtn) {
      discountBtn.textContent = isEnglish ? "Apply" : "Anwenden";
    }

    var summaryTitle = document.querySelector(".kaktusc-cart__total-left h4");
    if (summaryTitle) {
      summaryTitle.textContent = isEnglish ? "Total" : "Summe";
    }

    var checkoutBtn = document.querySelector(".kaktusc-cart__checkout");
    if (checkoutBtn) {
      checkoutBtn.textContent = isEnglish ? "Checkout" : "Zur Kasse";
    }

    var continueBtn = document.querySelector(".kaktusc-cart__continue");
    if (continueBtn) {
      continueBtn.textContent = isEnglish ? "Continue Shopping" : "Oder weiter shoppen";
    }

    var notesHeader = document.querySelector(".kaktusc-cart__notes-text");
    if (notesHeader) {
      notesHeader.textContent = isEnglish ? "Any special requests?" : "Möchtest du uns noch etwas mitteilen?";
    }
    console.log("Cart texts overridden (if elements were found)");
  }

  // 3. Setup a MutationObserver to catch dynamic additions (e.g. when the Cart Drawer loads).
  function setupCartObserver() {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node.
            if (node.matches && node.matches(".kaktusc-cart__body")) {
              console.log("Cart drawer detected via MutationObserver");
              overrideCartTexts();
            } else {
              var cartBody = node.querySelector && node.querySelector(".kaktusc-cart__body");
              if (cartBody) {
                console.log("Cart drawer detected inside added node");
                overrideCartTexts();
              }
            }
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    console.log("MutationObserver for cart drawer set up");
  }

  // 4. Fallback: Repeatedly check for the cart drawer every second for up to 10 seconds.
  function startIntervalCheck() {
    var maxChecks = 10;
    var checkCount = 0;
    var intervalId = setInterval(function() {
      checkCount++;
      var cartBody = document.querySelector(".kaktusc-cart__body");
      if (cartBody) {
        console.log("Cart drawer detected via interval check");
        overrideCartTexts();
        clearInterval(intervalId);
      } else {
        console.log("Interval check " + checkCount + ": Cart drawer not found yet.");
      }
      if (checkCount >= maxChecks) {
        clearInterval(intervalId);
      }
    }, 1000);
  }

  // Initialize everything once the DOM is ready.
  onReady(function() {
    console.log("DOM is ready, initializing cart overrides");
    injectCustomCSS();
    overrideCartTexts();
    setupCartObserver();
    startIntervalCheck();
  });
})();
